import axios, { AxiosResponse } from 'axios';
import createApiUrl from 'lib/create-api-url';

export const createFeedback = (data: {
  name: string;
  email: string;
  message: string;
  userAgent: string;
  emailUsedAsLogin: string | undefined;
}): Promise<AxiosResponse<unknown>> => {
  return axios.post(createApiUrl('/feedback'), data);
};
